import qccapis  from "../../api/qcc";
import apis from "../../api/index";
import flowapis  from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";

export default {
    name: "loanZjlAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
            activeName:'first',
            activeNameZx:'first',
            scrollHeight:400,
            query: {
                userName: "",
            },
            isVisible:this.visible,
            detailResult:{},
            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,
            llTableData:[],
            cllTableData:[],
            llListResult:[],
            llShow:false,
            cllShow:false,
            llquery:false,
            credit:{num:"暂无",comment:"暂无"},
            flowInfo:{},
            fileList:[],
            picList:[],
            fileList_FJ: [],
            reasonVisible:false,
            queryTime:dateUtils.dateToStr("yyyy-MM-dd hh:mm:00",new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,

            
            firstBusinessOption:['电商','种植','养殖','农产品加工','农资农机销售','农产品购销','农业服务','农业旅游农家乐','农业相关工程','其他'],
            secondBusinessTitle: '二级分类',
            secondBusinessPlaceHolder: '输入对应主营项目的二级类目',
 xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
            

            loanApply:{
              ApplyID:'',
              UserId:'',
              Phone:'',
              PersonCompanyText:'',
              PersonCompanyFlag:'',
              PersonCompanyKey:'',
              LoanTipsId:'',
              Money:'',
              CreateTime:'',
              BankID:'',
              BankSiteID:'',
              SiteDirectorID:'',
              FirstBusiness:'',
              SecondBusiness:'',
              PeopleCount:'',
              LastYearIncome:'',
              LastYearTax:'',
              LastYearProfit:'',
            },
            loanAudit: {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                hknl_value3:null,
                CreditRating:null,
                TotalAssets:null,
                AssetCoverage:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeId:null,
                Area:null,
                GuaranteeRate:null,
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
            },
            scorelist:[0,0,0,0,0,0],
            zxbglist:[],
            loanMortgage:[],
            loanCredit:{
              Id:null,
              keyword:null,
              num:null,
              createTime:null,
              danwei:null,
              money:null,
              comment2:null,
              comment2_gm:null,
              comment2_xy:null,
              comment2_js:null,
              comment:null,
              comment_xy:null,
              comment_gm:null,
              comment_js:null
            },
            loanCreditArea:{
              Id:null,
              keyword:null,
              name:null,
              area:null,
            },
            contractObj:null,
            khlx:[
              {
                  value:"公司",
                  label:"公司"
              },
              {
                  value:"个体户",
                  label:"个体户"
              },
              {
                  value:"种养大户",
                  label:"种养大户"
              },
              {
                value:"家庭农场",
                label:"家庭农场"
              },
              {
                value:"合作社",
                label:"合作社"
              }
            ],
            wfl:[
              {
                value:"正常贷款",
                label:"正常贷款"
              },
              {
                value:"关注贷款",
                label:"关注贷款"
              },
              {
                value:"次级贷款",
                label:"次级贷款"
              },
              {
                value:"可疑贷款",
                label:"可疑贷款"
              },
              {
                value:"损失贷款",
                label:"损失贷款"
              }
            ],
            khxz:[
              {
                  value:"新增",
                  label:"新增"
              },
              {
                  value:"续贷",
                  label:"续贷"
              },
              {
                  value:"展期",
                  label:"展期"
              }
            ],
            hkzt:[
              {
                  value:1,
                  label:"结清"
              },
              {
                  value:2,
                  label:"逾期"
              },
              {
                  value:3,
                  label:"代偿"
              }
            ],
            proTypeList:[],
            bankInfoObj:{},
            rules: {
              LoanYear: [
                  { required: true, message: '请填写担保函年份', trigger: 'change' },
              ],
              LoanTime:[
                  { required: true, message: '请填写合担保函序号', trigger: 'change' },
              ]
          }
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if(meta&&meta.permBtns.length>0){
          this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
      loanTypeChange(){
      },
      proTypeChange(){
      },
      onChangeClose(){
        this.isVisible = false
      },
      onChangeOpen(){
        this.isVisible = true
      },
      queryClick(flag){
        this.dataShow=true;
        this.sxtype=flag;
        if(this.caseResult[flag]>10)this.mlShow=true;
        else this.mlShow=false;
        this.pageIndex=1;
        this.sxdataList=this.getlistten(this.AllData[flag],1,10);
      },
      getlistten(list,pageIndex,pageSize){
        var newlist=[]
        for(var i=0;i<pageSize;i++){
          var j=i+(pageIndex-1)*pageSize;
          if(j<list.length)newlist.push(list[j]);
        }
        return newlist;
      },
      getList(flag){
        var type=this.sxtype;
        var that=this;
        var pageIndex=this.pageIndex+flag;
        if(pageIndex<1){that.$message.info("已经是第一页");return;}
        var allPage=(this.caseResult[this.sxtype]+9)/10;
        if(pageIndex>allPage){that.$message.info("已经是最后一页");return;};
        if(this.sxtype==2){
          this.pageIndex=pageIndex;
          this.sxdataList=this.getlistten(this.AllData[type],pageIndex,10);
        }else{
          let param1 = {
              id:that.flowInfo.Code,
              pageIndex:Math.ceil(pageIndex/2),
              type:Number(type)+1
           }
           
           qccapis.getCPCaseByType(param1).then(res => {
          if(res!=null){
            if(Number(res.Status)==200){
                var datalist=res.Result.Data;
                if(type==3){
                  for(var j=0;j<datalist.length;j++){
                    var roletype="";
                    if(datalist[j].IsProsecutor)roletype="原告";
                    if(datalist[j].IsDefendant)roletype="被告";
                    datalist[j].RoleType=roletype;
                    var partylist=datalist[j].PartyList;
                    for(var k=0;k<partylist.length;k++){
                       if(partylist[k].RoleType==roletype){
                        datalist[j].Statement=partylist[k].Statement
                       }
                    }
                  }
                }
                var danwei=pageIndex%2;
                if(danwei==0)danwei=2;
                that.pageIndex=pageIndex;
                var list=that.getlistten(res.Result.Data,danwei,10);
                that.sxdataList=list;
              }else{
               that.$message.error(res[i].Message)
              }
            }else{
             that.$message.error("查询信息失败")
           }
            });


        }
      },
      queryData(row){
        let that = this
        this.scorelist=[0,0,0,0,0,0]
        this.zxbglist=[]
        this.dataShow=false;
        this.sxdata=[];
        if(row){
          that.flowInfo = utils.deepCopy(row)

          if(!that.flowInfo.LoanYear){
            that.flowInfo.LoanYear = that.getCurrentYear()
          }

          if(that.flowInfo&&that.flowInfo.GuaranteeFee){
            that.flowInfo.GuaranteeFee = that.flowInfo.GuaranteeFee*1.0/1000000
          }
          if(that.flowInfo&&that.flowInfo.FinalMoney){
            that.flowInfo.FinalMoney = that.flowInfo.FinalMoney*1.0/1000000
          }

          if(that.flowInfo.PersonFlag===1){
            that.activeNameZx = 'second'
          }else{
            that.activeNameZx = 'first'
          }

          // 查询营业执照
          const yyzz = qccapis.getCPDetail({id:row.Code})
          // 诉讼信息
          const ssxx = qccapis.getCPCase({id:row.Code})
          // 查询老赖信息
          const llxx = qccapis.getLL({idCard:row.IdCard})
          // 查询老赖信息
          const llxx2 = qccapis.getLL({idCard:row.Code})

          // 查询审核信息 
          const shxx = flowapis.getLoanAuditInfo({
             flowId:that.flowInfo.Id,
             applyId:that.flowInfo.ApplyID,
             auditId:that.flowInfo.AuditID,
             IdCard:that.flowInfo.IdCard}
          )

          const fileInfo = flowapis.getLoanFiles({processId:that.flowInfo.Id,type:'2',uploadType:'2'})

          // // 查询政务信息
          // const promise3 = 

          Promise.all([yyzz, ssxx , llxx,llxx2,shxx,fileInfo]).then((res) => {
            if(res.length===6){
              if(res[0]&&res[0]['Result']){
                that.detailResult = res[0]['Result']
              }else{
                that.detailResult = {}
              }
            var qccres=res[1];
            if(qccres){
              that.sxdata=res;
              for(var i=0;i<4;i++){
                  if(Number(qccres[i].Status)==200){
                    if(qccres[i].Result.VerifyResult==0)that.caseResult[i]=0;
                    else {
                      if(i<2)that.caseResult[i] = qccres[i].Paging.TotalRecords;
                      if(i==2)that.caseResult[i]=qccres[i].Result.Data.length;
                      if(i==3){
                        that.caseResult[i] = qccres[i].Paging.TotalRecords;
                       var datalist=qccres[3].Result.Data;
                        for(var j=0;j<datalist.length;j++){
                          var roletype="";
                          if(datalist[j].IsProsecutor)roletype="原告";
                          if(datalist[j].IsDefendant)roletype="被告";
                          datalist[j].RoleType=roletype;
                          var partylist=datalist[j].PartyList;
                          for(var k=0;k<partylist.length;k++){
                             if(partylist[k].RoleType==roletype){
                              datalist[j].Statement=partylist[k].Statement
                             }
                          }
                        }
                      }
                      that.AllData[i]=that.AllData[i].concat(qccres[i].Result.Data);
                      if(!that.dataShow){
                           that.dataShow=true;
                           that.sxtype=i;
                           that.sxdataList=that.getlistten(qccres[i].Result.Data,1,10);
                           if(that.caseResult[i]>10)that.mlShow=true;
                      }

                    }
                }else{
                  that.caseResult[i]="";
                }
               }
          }
               if(res[2]){
                that.llTableData=res[2].list;
               }
              if(res[4]){
                if(res[4].applyObj){
                  that.loanApply = res[4].applyObj
                  that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                }else{
                  that.setEmptyApply()
                }
                if(res[4].auditObj){
                  that.loanAudit = res[4].auditObj
                  if(that.loanAudit.GuaranteeLetterTime){
                    that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                  }
                  if(that.loanAudit.LoanEndTime){
                    that.loanAudit.LoanEndTime= new Date(that.loanAudit.LoanEndTime)
                  }
                  if(that.loanAudit.LoanMoney){
                    that.loanAudit.LoanMoney = Math.floor(that.loanAudit.LoanMoney*1.0)/100.0
                  }
                  if(that.loanAudit.scoreList){
                    that.scorelist = that.loanAudit.scoreList.split(",")
                }
                if(that.loanAudit.zxbgList){
                  that.zxbglist = JSON.parse(that.loanAudit.zxbgList)
                }
                if(that.loanAudit.ThirdBusiness){
                  that.loanAudit.ThirdBusiness=that.loanAudit.ThirdBusiness.toString().split(",");
                }else{
                  that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                  that.loanAudit.Business=that.loanApply.FirstBusiness
                  that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                }
                }else{
                  that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                  that.loanAudit.Business=that.loanApply.FirstBusiness
                  that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                  that.setEmptyAudit()
                }
                if(res[4].contractObj){
                  that.contractObj = res[4].contractObj
                }
                if(res[4].mortgageObj){
                  that.loanMortgage = res[4].mortgageObj
                }else{
                  that.loanMortgage = []
                }
                if(res[4].proTypeList){
                  that.proTypeList = res[4].proTypeList
                }else{
                  that.proTypeList = []
                }
                if(res[4].bankInfoObj){
                  that.bankInfoObj = res[4].bankInfoObj
                }else{
                  that.bankInfoObj = {}
                }
                if(res[4].loanCreditObj){
                  that.loanCredit = res[4].loanCreditObj
                }else{
                  that.setEmptyCredit()
                }
                if(res[4].loanCreditAreaObj){
                  that.loanCreditArea = res[4].loanCreditAreaObj
                }else{
                  that.setEmptyCreditArea()
                }
                if(res[5]&&res[5].length>0){
                  that.fileList_FJ = []
                  for(let f=0;f<res[5].length;f++){
                    that.fileList_FJ.push({
                      name:res[5][f]['Name'],
                      url:res[5][f]['Url']
                    })
                  }
                }else{
                    that.fileList_FJ = []
                }
              }else{
                that.setEmptyApply()
                that.setEmptyAudit()
                that.loanMortgage = []
                that.setEmptyCredit()
                that.setEmptyCreditArea()
              }
            }
          })
        }
      },
      beforeAvatarPicUpload(file) {
          let that = this
          const isJPG = 
              file.type ==="image/jpg"||
              file.type ==="image/jpeg"||
              file.type ==="image/png"
          const isLt2M = file.size/1024/1024 <2
          if(!isJPG){
              that.$message.error("仅支持jpg、png格式的图片")
          }
          if(!isLt2M){
              that.$message.error("上传图片大小不能超过2MB") 
          }
          return isJPG && isLt2M
      },
      uploadPicFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.picList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
        }
        return true
      },
      uploadFileFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.fileList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handlePicRemove(file) {
        let that = this
        if(file){
          for(let i=0;i<that.picList.length;i++){
            if(file.url===that.picList[i].url){
              that.picList.splice(i,1)
            }
          }
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePicDownload(file) {
        if(file){
          const blob = new Blob([file.url],{type:'application/vnd.ms-excel'})
          const elink = document.createElement('a')
          elink.download = file.name
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
      },

      setObjEmptyToNull(obj){
        Object.keys(obj).forEach(function(key, index) {
          if (this[key] === '') this[key] = null;
        }, obj);
        return obj
      },

      /**
       * 审核通过
       */
      onPassFlow(){
        let that = this
        let param = {
          Id:that.flowInfo.Id,
          Route:13
        }
        flowapis.updateFlow(param).then((res) => {
          if(res&&res.code){
            // that.$emit('bankauditsucess');
            that.onChangeClose()
            this.$parent.bankAuditSucess()
          }else{
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
      },
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40-20;
          this.scrollHeight = height;
        });
      },
      setEmptyApply(){
        let that = this
        that.loanApply = {
            ApplyID:'',
            UserId:'',
            Phone:'',
            PersonCompanyText:'',
            PersonCompanyFlag:'',
            PersonCompanyKey:'',
            LoanTipsId:'',
            Money:'',
            CreateTime:'',
            BankID:'',
            BankSiteID:'',
            SiteDirectorID:'',
            FirstBusiness:'',
            SecondBusiness:'',
            PeopleCount:'',
            LastYearIncome:'',
            LastYearTax:'',
            LastYearProfit:'',
        }
      },
      setEmptyAudit(){
        let that = this
        that.loanAudit = {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                hknl_value3:null,
                CreditRating:null,
                TotalAssets:null,
                AssetCoverage:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeName:null,
                Area:null,
                GuaranteeRate:null,
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
            }
            this.scorelist=[0,0,0,0,0,0]
            this.zxbglist=[]
      },
      setEmptyCredit(){
        let that = this
        that.loanCredit = {
          Id:null,
          keyword:null,
          num:null,
          createTime:null,
          danwei:null,
          money:null,
          comment2:null,
          comment2_gm:null,
          comment2_xy:null,
          comment2_js:null,
          comment:null,
          comment_xy:null,
          comment_gm:null,
          comment_js:null
        }
      },
      setEmptyCreditArea(){
        let that = this
        that.loanCreditArea = {
          Id:null,
          keyword:null,
          name:null,
          area:null,
        }
      },
      onFirstBusinessChooseConfirm(value){
        //变更二级分类的标题和placeholder
        this.changeSecondBusinessShow(value)
      },
      changeSecondBusinessShow(value){
          switch (value) {
              case '电商':
                  this.secondBusinessTitle = '销售类目'
                  this.secondBusinessPlaceHolder = '如：生鲜、粮油'
                  break;
              case '种植':
                  this.secondBusinessTitle = '种植作物'
                  this.secondBusinessPlaceHolder = '如：水稻、棉花'
                  break;
              case '养殖':
                  this.secondBusinessTitle = '养殖种类'
                  this.secondBusinessPlaceHolder = '如：猪、肉牛'
                  break;
              case '农产品加工':
                  this.secondBusinessTitle = '加工品类'
                  this.secondBusinessPlaceHolder = '如：粮食加工、柑橘加工'
                  break;
              case '农资农机销售':
                  this.secondBusinessTitle = '销售品类'
                  this.secondBusinessPlaceHolder = '如：播种机、拖拉机、农资销售'
                  break;
              case '农产品购销':
                  this.secondBusinessTitle = '产品类型'
                  this.secondBusinessPlaceHolder = '如：柑橘、蔬菜'
                  break;
              case '农业服务':
                  this.secondBusinessTitle = '服务项目'
                  this.secondBusinessPlaceHolder = '如：收割、无人机植保'
                  break;
              case '农业旅游农家乐':
                  this.secondBusinessTitle = '产业类型'
                  this.secondBusinessPlaceHolder = '如：玫瑰园、果园、农家乐餐饮'
                  break;
              case '农业相关工程':
                  this.secondBusinessTitle = '工程内容'
                  this.secondBusinessPlaceHolder = '如：大棚、土壤改良、绿化工程'
                  break;
              case '其他':
                  this.secondBusinessTitle = '经营项目'
                  this.secondBusinessPlaceHolder = '请填经营项目'
                  break;
          }
      },
      getCurrentYear(){
        let date = new Date; // Sat Jul 06 2019 19:59:27 GMT+0800 (中国标准时间)
        let year = date.getFullYear(); // 2019
        return year
      },
      onDownChange(path){
        window.open(path)
      }
    },
  };
